"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require("babel-runtime/helpers/extends");

var _extends5 = _interopRequireDefault(_extends4);

var _actionTypes = require("../constants/action-types");

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initial = {
  locale: "en-US",
  fallback: "en-US",
  translatedString: {},
  appResourcesLoaded: false,
  productResourcesLoaded: false,
  resources: {}
};

var reducer = function reducer() {
  var _resources;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    case _actionTypes2.default.INIT_LION:
      return (0, _extends5.default)({}, state, {
        locale: action.payload.locale,
        fallback: action.payload.fallbackLocale,
        resources: (_resources = {}, (0, _defineProperty3.default)(_resources, action.payload.fallbackLocale, {
          app: action.payload.fallbackAppResources,
          product: action.payload.fallbackProductResources
        }), (0, _defineProperty3.default)(_resources, action.payload.locale, {
          app: action.payload.appResources,
          product: action.payload.productResources
        }), _resources),
        appResourcesLoaded: true,
        productResourcesLoaded: true
      });

    case _actionTypes2.default.LION_SET_LANGUAGE:
      var lionLocale = action.payload;
      return (0, _extends5.default)({}, state, {
        locale: lionLocale
      });
    case _actionTypes2.default.LION_SET_FALLBACK_LANGUAGE:
      var lionFallbackLocale = action.payload;
      return (0, _extends5.default)({}, state, {
        fallback: lionFallbackLocale
      });

    case _actionTypes2.default.LION_SET_RESOURCES_APP:
      var appLocale = action.payload.locale ? action.payload.locale : state.locale;
      var appResources = action.payload.resources;
      return (0, _extends5.default)({}, state, {
        resources: (0, _extends5.default)({}, state.resources, (0, _defineProperty3.default)({}, appLocale, (0, _extends5.default)({}, state.resources[appLocale], {
          app: appResources
        })))
      });
    case _actionTypes2.default.LION_SET_RESOURCES_APP_LOADED:
      return (0, _extends5.default)({}, state, {
        appResourcesLoaded: action.payload
      });

    case _actionTypes2.default.LION_SET_RESOURCES_PRODUCT:
      var productLocale = action.payload.locale ? action.payload.locale : state.locale;
      var productResources = action.payload.resources;
      return (0, _extends5.default)({}, state, {
        resources: (0, _extends5.default)({}, state.resources, (0, _defineProperty3.default)({}, productLocale, (0, _extends5.default)({}, state.resources[productLocale], {
          product: productResources
        })))
      });
    case _actionTypes2.default.LION_SET_RESOURCES_PRODUCT_LOADED:
      return (0, _extends5.default)({}, state, {
        productResourcesLoaded: action.payload
      });

    default:
      return state;
  }
};

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/dist/reducer/lion-reducer.js
// module id = 895
// module chunks = 0